/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import { PREQUALIFIED_DESIGN_CODE_YEAR_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';
import getDesignCodeYearDescFromDesignCodeYear from '#support/models/getDesignCodeYearDescFromDesignCodeYear.js';

const optionIdPrefix = 'ep-design-code-select-option';
const { YEARS, OVERRIDE } = PREQUALIFIED_DESIGN_CODE_YEAR_VALUES;
const options = [
  ...YEARS.map(year => ({
    id: `${optionIdPrefix}-${year}`,
    name: getDesignCodeYearDescFromDesignCodeYear(year),
    value: year,
  })),
  {
    id: `${optionIdPrefix}-override`,
    name: 'User Defined Accelerations',
    value: OVERRIDE,
  },
];

type Props = {|
  form: string,
  name: string,
|};

const EquipmentPrequalifiedDesignCodeYearSelectMenu = ({
  form,
  name,
}: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={options}
    id={name}
    name={name}
    inputClassName={classNames('custom-select', 'equipment-prequalified-design-code-year-select')}
    includeEmptyOption
  />
);

export default EquipmentPrequalifiedDesignCodeYearSelectMenu;
